import type { Farming } from '@/interfaces/farming.interface'
import { HttpMethod, Performer } from '../core'

export class GetFarming extends Performer<
  void,
  {
    farming: Farming
  }
> {
  protected method = HttpMethod.GET
  protected url = '/get-farming'
}
